import { HttpClient } from "@angular/common/http";
import { Component } from "@angular/core";
import * as Papa from "papaparse";

@Component({
  selector: "app-data-automation",
  templateUrl: "./data-automation.component.html",
  styleUrls: ["./data-automation.component.scss"],
})
export class DataAutomationComponent {
  constructor(private http: HttpClient) {}
  processData() {
    console.log("X");
    const csvFilePath =
      "/assets/data/DataSheets/BI-Advanced Report-Project Tracker-Commitments 2.0.csv";

    this.http.get(csvFilePath, { responseType: "text" }).subscribe(
      (csvContent) => {
        this.parseCSV(csvContent)
          .then((parsedData) => {
            console.log(parsedData);
          })
          .catch((error) => {
            // Handle the error
          });
      },
      (error) => {
        // Handle the error
      },
    );
  }

  parseCSV(csvContent: string): Promise<any[]> {
    return new Promise((resolve, reject) => {
      Papa.parse(csvContent, {
        complete: (result) => {
          resolve(result.data);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }
}
